import { createFileRoute } from '@tanstack/react-router';
import { KanbanBoard } from '@/features/tasks/KanbanBoard';

export const Route = createFileRoute('/_app/tasks/kanban')({ component: KanbanBoard });
